import { TableBody } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import React from "react";
import { useTranslation } from "react-i18next";

import { Mortgage } from "../../../../../model/MortgageExtensionModel";
import { formatAmount } from "../../../../../utils/NumberUtils";
import { MortgageSummaryBold, MortgageSummaryLabel } from "../../../2-summary/NewMortgageSummary";

const MortgageTotalDesktop = (props: { newMortgage?: Mortgage }) => {
    const { t } = useTranslation();
    const { newMortgage } = props;

    return (
        <TableBody>
            <TableRow>
                <TableCell colSpan={2} sx={{ border: "none", padding: "16px 16px 0 16px" }}>
                    <MortgageSummaryBold>
                        {t("ConfigurationScreen.Total charge after mortgage extension (as of today)")}
                    </MortgageSummaryBold>
                </TableCell>
                <TableCell align="right" sx={{ border: "none", padding: "16px 16px 0 16px" }} rowSpan={2}>
                    <MortgageSummaryBold>{formatAmount(newMortgage?.totalSumLiabilities ?? 0)}</MortgageSummaryBold>
                </TableCell>
                <TableCell align="right" sx={{ border: "none", padding: "16px 16px 0 16px" }} colSpan={2} rowSpan={2}>
                    <MortgageSummaryBold>
                        {formatAmount(newMortgage?.totalSumLiabilitiesMonthly ?? 0)}
                    </MortgageSummaryBold>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell colSpan={2} sx={{ border: "none", padding: "0 16px" }}>
                    <MortgageSummaryLabel>{t("ConfigurationScreen.Excluding additional costs")}</MortgageSummaryLabel>
                </TableCell>
            </TableRow>
        </TableBody>
    );
};
export default MortgageTotalDesktop;
